import {
  Button,
  Icon,
  IconButton,
  Typography,
} from '@wisecare-tech/design-system-web';
import React from 'react';

import { MessageOptions } from 'domain/interfaces/redux/message';
import { closeModal } from 'utils/closeModal';

import { ownProps } from '../interface';
import {
  Container,
  ContainerModal,
  Content,
  EmailField,
  EmailSection,
  Footer,
  Header,
  IconWrapper,
} from './styles/StyledExternalLoginError';

const ExternalLoginError: React.FC<ownProps> = ({ message }) => {
  const msgName = MessageOptions.externalLoginError;

  const { active, actionOk, data } = message;

  const email: string | undefined = data?.email;
  const title: string = data?.title ?? 'E-mail não vinculado';
  const description: string =
    data?.description ??
    'Seu e-mail institucional não está cadastrado no PBMeet. Entre em contato com o responsável de sua organização para mais informações.';

  if (msgName !== active) return null;

  return (
    <ContainerModal>
      <Container>
        <Header>
          <IconWrapper>
            <Icon name="error" size="h5" color="red-7" />
          </IconWrapper>
          <IconButton
            variant="primary"
            icon="close"
            size="sm"
            onClick={closeModal}
          />
        </Header>
        <Content>
          <Typography variant="t4_16medium">{title}</Typography>
          <Typography variant="b4_14regular" style={{ color: '#656a6e' }}>
            {description}
          </Typography>
        </Content>
        {email ? (
          <EmailSection>
            <Typography variant="b3_14medium">E-mail institucional</Typography>
            <EmailField>{email}</EmailField>
          </EmailSection>
        ) : null}
        <Footer>
          <Button
            variant="primary"
            autoFocus
            onClick={() => {
              actionOk?.();
              closeModal();
            }}
          >
            Entendi
          </Button>
        </Footer>
      </Container>
    </ContainerModal>
  );
};

export default ExternalLoginError;
